import React from "react";
import { useStoryNavigation } from "@/hooks/useStoryNavigation";
import { ArrowUpRight } from "lucide-react";

interface StoryCodeActionButtonsProps {
  filePath?: string;
  className?: string;
}

export const StoryCodeActionButtons: React.FC<StoryCodeActionButtonsProps> = ({
  filePath,
  className = "",
}) => {
  const { isStoryFile, navigateToStorySubcanvas } = useStoryNavigation();

  const showStoryButton = filePath && isStoryFile(filePath);

  // Don't render anything if there are no buttons to show
  if (!showStoryButton) {
    return null;
  }

  return showStoryButton ? (
    <button
      onClick={(e) => {
        e.stopPropagation();
        navigateToStorySubcanvas(filePath);
      }}
      className={`group/story-btn relative flex items-center gap-1 px-1.5 py-0.5 bg-secondary-n-950 rounded transition-colors ${className}`}
      data-tooltip-id="tooltip"
      data-tooltip-content="Open stories"
      data-tooltip-place="top"
    >
      <img
        src="/icons/storybook.svg"
        alt="storybook icon"
        className="w-3.5 h-3.5 opacity-70 group-hover/story-btn:opacity-0 transition-opacity duration-200"
      />
      <ArrowUpRight
        className="size-3.5 opacity-0 group-hover/story-btn:opacity-70 transition-opacity duration-200 absolute text-white shrink-0"
        strokeWidth={2}
      />
    </button>
  ) : null;
};
